"use strict";

import React from 'react';
import Accounting from "accounting";

const OrderTrailingSummary = ({isTopsOrder=false, order={}}) => {
    if( !!order && Object.keys(order).length ){
        return (
            <div className="row cart-summary">
                <div className="cart__final-summary__column">
                    <dl className="cart__final-summary__list">
                        <dt className="cart__final-summary__list-item__name">Subtotal:</dt>
                        <dd className="cart__final-summary__list-item__value">
                            { !!order.order_subtotal ? Accounting.formatMoney(order.order_subtotal) : '\u00A0'}
                        </dd>
                    </dl>
                    { order.order_discount_total > 0 &&
                    <dl className="cart__final-summary__list">
                        <dt className="cart__final-summary__list-item__name">- Discount:</dt>
                        <dd className="cart__final-summary__list-item__value">
                            -{Accounting.formatMoney(order.order_discount_total)}
                        </dd>
                    </dl>
                    }
                    <dl className="cart__final-summary__list">
                        <dt className="cart__final-summary__list-item__name">+ Shipping Charges:</dt>
                        <dd className="cart__final-summary__list-item__value">
                            { !!order.shipping_total ? Accounting.formatMoney(order.shipping_total) : '\u00A0'}
                        </dd>
                    </dl>
                    { !!order?.shipping_discount_total && +order.shipping_discount_total > 0 &&
                        <dl className="cart__final-summary__list">
                            <dt className="cart__final-summary__list-item__name">- Shipping Discount:</dt>
                            <dd className="cart__final-summary__list-item__value">
                                -{Accounting.formatMoney(order.shipping_discount_total)}
                            </dd>
                        </dl>
                    }
                    { order.tax > 0 &&
                    <dl className="cart__final-summary__list">
                        <dt className="cart__final-summary__list-item__name">+ Sales Tax:</dt>
                        <dd className="cart__final-summary__list-item__value">{Accounting.formatMoney(order.tax)}</dd>
                    </dl>
                    }
                    <dl className="cart__final-summary__list">
                        <dt className="cart__final-summary__list-item__name cart__final-summary__list-item__name--grand-total">
                            = <strong>TOTAL:</strong>
                        </dt>
                        <dd className="cart__final-summary__list-item__value cart__final-summary__list-item__value--grand-total">
                            <strong>{Accounting.formatMoney(order.total_amount)}</strong>
                        </dd>
                    </dl>
                </div>
                <div className="cart__summary-notes__column">
                    { !isTopsOrder && !!order.notes &&
                    <p className="note">
                        <strong className="uppercase">Order Notes:</strong> {order.notes}
                    </p>
                    }
                </div>
            </div>
        );
    }
    return null;
};

export default OrderTrailingSummary;